let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kznsK")).then(() => parcelRequire('8VlAg'));